export class CollectionScrollPosition {
  constructor () {
    // Last clicked item data
    this.lastClickedItemHrefKey = 'collectionScrollPosition-lastClickedItemHref'
    this.lastClickedItemHref = sessionStorage.getItem(
      this.lastClickedItemHrefKey,
    )

    // Last visited url data
    this.lastVisitedUrlsKey =
      'collectionScrollPosition-lastVisitedCollectionUrl'
    this.lastVisitedUrls = sessionStorage.getItem(this.lastVisitedUrlsKey)

    this.currentUrl = this.urlToPathName(window.location.href)

    this.init()
  }

  init () {
    if (this.currentUrl.includes('/collections/')) {
      this.handleCollectionTemplate()
    } else if (this.currentUrl.includes('/products/')) {
      this.handleProductTemplate()
    } else {
      this.clearData()
    }
  }

  handleCollectionTemplate () {
    this.checkLastVisistedUrls(this.currentUrl)

    // Disable browser's native scrollRestoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    if (this.lastVisitedCollectionUrl === this.currentUrl) {
      this.clearData()
    }

    this.restoreScrollPosition()
    this.captureClickedItemHref()
  }

  handleProductTemplate () {
    this.checkLastVisistedUrls(this.currentUrl)

    if (!this.lastClickedItemHref) return

    const currentPath = new URL(this.currentUrl, window.location.origin)
      .pathname

    let lastClickedPath
    try {
      lastClickedPath = new URL(
        this.lastClickedItemHref,
        window.location.origin,
      ).pathname
    } catch (e) {
      console.warn('Invalid lastClickedItemHref:', this.lastClickedItemHref)
      this.clearData()
      return
    }

    if (currentPath !== lastClickedPath) {
      this.clearData()
    }
  }

  restoreScrollPosition () {
    // Retrieve and restore last position
    if (!this.lastClickedItemHref) return

    const elementSelector = `a[href="${this.lastClickedItemHref}"]`

    const attemptToScrollIntoView = () => {
      const element = document.querySelector(elementSelector)
      if (!element) return
      element.scrollIntoView({
        behavior: 'instant',
        block: 'center',
        inline: 'center',
      })
      document.removeEventListener(
        'collectionRendered',
        attemptToScrollIntoView,
      )
    }

    // Attempt on page load
    attemptToScrollIntoView()

    // Attempt once collection has been fully rendered
    document.addEventListener('collectionRendered', attemptToScrollIntoView)
  }

  captureClickedItemHref () {
    // Capture clicked item href
    //
    // Note: If the load-more-list.js custom element is in use, the below will not work.
    // This is due to 'non-drag anchor click' logic that lives within the custom element
    // that prevents default behaviour on click events. As a work around, the sessionStorage
    // function also takes place within the load-more-list script. To find this code, search
    // for the string 'Set storage data for collection-scroll-position.js'.

    window.addEventListener('click', e => {
      if (
        e.target.classList.contains('prd-Card_FauxLink') ||
        e.target.classList.contains('prd-Card_Link') ||
        e.target.classList.contains('clc-LifestyleBlock_FauxLink')
      ) {
        this.lastClickedItemHref = e.target.getAttribute('href')?.split('?')[0]

        sessionStorage.setItem(
          this.lastClickedItemHrefKey,
          this.lastClickedItemHref?.toString(),
        )
      }
    })
  }

  checkLastVisistedUrls (url) {
    const array = this.lastVisitedUrls
      ? [...JSON.parse(this.lastVisitedUrls)]
      : []
    array.push(url)
    if (array[array.length - 1] === array[array.length - 2]) {
      this.clearData()
    } else {
      sessionStorage.setItem(this.lastVisitedUrlsKey, JSON.stringify(array))
    }
  }

  clearData () {
    sessionStorage.removeItem(this.lastClickedItemHrefKey)
    sessionStorage.removeItem(this.lastVisitedUrlsKey)
    this.lastClickedItemHref = null
    this.lastVisitedUrls = null
  }

  urlToPathName (url) {
    const object = new URL(url)
    return object.pathname
  }
}

/* eslint-disable */
// iOS Safari fix to ensure scroll position is restored on page reload after pressing back button.
;(function () {
  window.onpageshow = function (event) {
    if (event.persisted) {
      new CollectionScrollPosition()
    }
  }
})()

document.addEventListener('DOMContentLoaded', () => {
  new CollectionScrollPosition()
})
/* eslint-enable */
